import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { GridCellParams } from '@mui/x-data-grid-pro';
import { Box } from '@mui/material';
import { missingField } from 'app/constants';
import { navigationProfilesAction } from '@AMIEWEB/GlobalSearch/store/NavigationProfiles.redux';
import { useDispatch } from 'react-redux';

type Field = 'candidateId' | 'candidate';

export const CandidateLinkCell = (field: Field) => (params: GridCellParams) => {
  const dispatch = useDispatch();
  const row = params?.row ?? {};
  const candidateId = row.candidateId ?? row.travelerID ?? row.travelerId ?? null;
  const candidateName = (row.candidate ?? '-').toString();
  const brandId = row.brandId ?? row.brandID ?? row.BrandId ?? 0;
  const link = `/candidate/${candidateId}/${brandId}`;

  const displayValue =
    field === 'candidateId' ? (candidateId != null ? String(candidateId) : missingField) : candidateName;

  const handleClick = () => {
    dispatch(navigationProfilesAction.setNavigationFlag({ navigationFromGrid: true }));
    dispatch(navigationProfilesAction.setCurrentRowId({ rowId: params?.row?.id }));
  };

  if (candidateId == null && field === 'candidateId') {
    return (
      <Box component="span" sx={{ color: 'text.secondary', fontSize: 14 }}>
        {missingField}
      </Box>
    );
  }

  if (candidateId == null) {
    return (
      <Box component="span" sx={{ fontSize: 14 }}>
        {candidateName}
      </Box>
    );
  }

  return (
    <Box
      component={RouterLink}
      to={link}
      onClick={handleClick}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        color: 'primary.main',
        textDecoration: 'none',
        fontSize: 14,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'block',
        '&:hover': { color: 'primary.dark', textDecoration: 'underline' },
      }}
    >
      {displayValue}
    </Box>
  );
};
